<template>
  <div class="pa-4 header_detail" style="font-size: 26px">
    <div>{{ $props.name }}</div>
    <div>จำนวนรวม <b>{{ $props.total }}</b> {{ $props.type }}</div>
  </div>
</template>

<script>
export default {
  name: "HeaderDetails",
  props: ['name', 'total', 'type'],
}
</script>

<style scoped>
.header_detail {
  display: flex;
  justify-content: space-between;
}
@media only screen and (max-width: 500px) {
  .header_detail {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
    text-align: center;
  }
}
</style>
